import { ToggleButton, ToggleButtonGroup } from "@mui/material";
import FlashOnIcon from "@mui/icons-material/FlashOn";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";

interface Props {
  deliveryType: number;
  handleDeliveryType: (deliveryType: number) => void;
  availableDeliveryTypes?: number[];
}

const DeliveryTypeSwitch: React.FC<Props> = ({ deliveryType, handleDeliveryType, availableDeliveryTypes = [1, 2] }) => {
  const handleChange = (_: any, newValue: number | null) => {
    if (newValue !== null) {
      handleDeliveryType(newValue);
    }
  };

  const showStandard = availableDeliveryTypes.includes(1);
  const showQuick = availableDeliveryTypes.includes(2);

  // If no delivery types available, don't render anything
  if (!showStandard && !showQuick) {
    return null;
  }

  return (
    <ToggleButtonGroup
      value={deliveryType}
      exclusive
      onChange={handleChange}
      sx={{
        mt: { xs: 1, sm: 0 },
        alignSelf: { xs: "flex-start", sm: "center" },
      }}
    >
      {showStandard && (
        <ToggleButton value={1} sx={{ px: 3, py: 1 }}>
          <LocalShippingIcon fontSize="small" sx={{ mr: 1 }} />
          Standard
        </ToggleButton>
      )}
      {showQuick && (
        <ToggleButton value={2} sx={{ px: 3, py: 1 }}>
          <FlashOnIcon fontSize="small" sx={{ mr: 1 }} />
          Quick
        </ToggleButton>
      )}
    </ToggleButtonGroup>
  );
};

export default DeliveryTypeSwitch;
